/// Tamanho de arquivo como a pessoa lê: KB abaixo de 1 MB, nunca "0 KB".
const sizeFormat = new Intl.NumberFormat('pt-BR', { maximumFractionDigits: 1 });
export function formatFileSize(bytes: number) {
  if (bytes < 1024 * 1024) return `${sizeFormat.format(Math.max(1, Math.round(bytes / 1024)))} KB`;
  return `${sizeFormat.format(bytes / (1024 * 1024))} MB`;
}
